//实验名称参数:
const testNames = {
  a: "构件辨识实验",
  b: "平身科搭建实验",
  c: "柱额层搭建实验",
  d: "斗栱层搭建实验",
  e: "屋架层搭建实验",
  f: "椽望层搭建实验"
};
//实验满分参数
const fullGrade = {
  a: 100,
  b: 100,
  c: 100,
  d: 100,
  e: 100,
  f: 100
};

const simpleFullGrade = 100;
const testNameList = Object.keys(testNames).map(name => testNames[name]);

export { testNames, fullGrade, testNameList, simpleFullGrade };
